<script lang="ts">
	import { editable } from '../editable';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: Array<ISbStoryData['content']>;
			desktop_spacing?: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	class={[
		{
			'lg:m-5 lg:overflow-hidden lg:rounded-2xl': content.desktop_spacing,
			'lg:-mb-[1px]': !content.desktop_spacing
		}
	]}
	use:editable={content}
	style="height: calc(100svh - var(--full-header-height));"
>
	{#if content.asset?.length > 0}
		<Blok content={content.asset[0]} />
	{/if}
</div>
